import DialogNew from './DialogNew'

export default DialogNew
